// @ts-check

/** @type {Array<[string, RegExp, string[]?]>} */
const ROUTES = [
  ["home", /^#?\/?home\/?$/],
  ["daily", /^#?\/?daily\/?$/],
  ["archive", /^#?\/?archive\/?$/],
  ["journey", /^#?\/?journey\/?$/],
  ["pack", /^#?\/?pack\/([a-z0-9_]+)\/?$/, ["packId"]],
  ["item", /^#?\/?item\/([a-z0-9_]+)\/?$/, ["collectionItemId"]],
  ["quick-play", /^#?\/?quick-play\/?$/],
  ["play", /^#?\/?play\/([a-z0-9_]+)\/?$/, ["puzzleId"]],
  ["complete", /^#?\/?complete\/([a-z0-9_]+)\/?$/, ["puzzleId"]],
  ["collection", /^#?\/?collection\/?$/],
  ["stats", /^#?\/?stats\/?$/],
  ["learn", /^#?\/?learn\/?$/],
  ["settings", /^#?\/?settings\/?$/],
  ["about", /^#?\/?about\/?$/],
];

export function parseRoute(hash = location.hash) {
  const normalized = hash || "#/home";
  for (const [name, pattern, keys = []] of ROUTES) {
    const match = normalized.match(pattern);
    if (match)
      return {
        name,
        params: Object.fromEntries(
          keys.map((key, index) => [key, match[index + 1]]),
        ),
      };
  }
  return { name: "not-found", params: {} };
}

export function navigate(path) {
  location.hash = path.startsWith("#")
    ? path
    : `#${path.startsWith("/") ? path : `/${path}`}`;
}
